var map = {
	"./nn/dictation/diktat-12.mp3": 90,
	"./nn/dictation/diktat-13.mp3": 91,
	"./nn/dictation/diktat-15.mp3": 92,
	"./nn/dictation/diktat-16.mp3": 93,
	"./nn/dictation/diktat-17.mp3": 94,
	"./nn/dictation/diktat-19.mp3": 95,
	"./nn/dictation/diktat-21.mp3": 96,
	"./nn/dictation/diktat-24.mp3": 97,
	"./nn/dictation/diktat-28.mp3": 98,
	"./nn/dictation/diktat-35.mp3": 99,
	"./nn/dictation/diktat-36.mp3": 100,
	"./nn/dictation/diktat-38.mp3": 101,
	"./nn/dictation/diktat-39.mp3": 102,
	"./nn/dictation/diktat-intro.mp3": 211,
	"./nn/intros/letterKnowledge-intro.mp3": 212,
	"./nn/intros/oneMinute-intro.mp3": 213,
	"./nn/intros/pd-intro.mp3": 214,
	"./nn/intros/phonemeIsolation-klarte-oppgaver.mp3": 210,
	"./nn/intros/phonemeIsolation-starter-intro.mp3": 209,
	"./nn/intros/testen-er-ferdig.mp3": 469,
	"./nn/intros/workingmemory-numbers-intro.mp3": 139,
	"./nn/intros/workingmemory-words-intro.mp3": 196,
	"./nn/phonemeDeletion/brev-b.mp3": 215,
	"./nn/phonemeDeletion/brev.mp3": 470,
	"./nn/phonemeDeletion/broed-b.mp3": 216,
	"./nn/phonemeDeletion/bru-r.mp3": 217,
	"./nn/phonemeDeletion/bry-r.mp3": 218,
	"./nn/phonemeDeletion/drap-d.mp3": 219,
	"./nn/phonemeDeletion/foere-f.mp3": 220,
	"./nn/phonemeDeletion/foere.mp3": 221,
	"./nn/phonemeDeletion/gaas-g.mp3": 222,
	"./nn/phonemeDeletion/gris-g.mp3": 223,
	"./nn/phonemeDeletion/gris.mp3": 224,
	"./nn/phonemeDeletion/klatre-t.mp3": 225,
	"./nn/phonemeDeletion/klede-k.mp3": 226,
	"./nn/phonemeDeletion/laas-s.mp3": 227,
	"./nn/phonemeDeletion/lekse-k.mp3": 228,
	"./nn/phonemeDeletion/loff-f.mp3": 229,
	"./nn/phonemeDeletion/maal-m.mp3": 230,
	"./nn/phonemeDeletion/malt-l.mp3": 231,
	"./nn/phonemeDeletion/sel-l.mp3": 232,
	"./nn/phonemeDeletion/sel.mp3": 233,
	"./nn/phonemeDeletion/skyl-l.mp3": 234,
	"./nn/phonemeDeletion/sport-p.mp3": 235,
	"./nn/phonemeDeletion/trygg-t.mp3": 236,
	"./nn/phonemeIsolation/ends_with_e.mp3": 471,
	"./nn/phonemeIsolation/ends_with_i.mp3": 472,
	"./nn/phonemeIsolation/ends_with_k.mp3": 473,
	"./nn/phonemeIsolation/ends_with_n.mp3": 474,
	"./nn/phonemeIsolation/ends_with_o.mp3": 475,
	"./nn/phonemeIsolation/ends_with_p.mp3": 476,
	"./nn/phonemeIsolation/ends_with_r.mp3": 477,
	"./nn/phonemeIsolation/ends_with_t.mp3": 478,
	"./nn/phonemeIsolation/ends_with_u.mp3": 479,
	"./nn/phonemeIsolation/ends_with_y.mp3": 480,
	"./nn/phonemeIsolation/starts_with_b.mp3": 481,
	"./nn/phonemeIsolation/starts_with_e.mp3": 482,
	"./nn/phonemeIsolation/starts_with_g.mp3": 483,
	"./nn/phonemeIsolation/starts_with_h.mp3": 484,
	"./nn/phonemeIsolation/starts_with_i.mp3": 485,
	"./nn/phonemeIsolation/starts_with_k.mp3": 486,
	"./nn/phonemeIsolation/starts_with_l.mp3": 487,
	"./nn/phonemeIsolation/starts_with_oe.mp3": 488,
	"./nn/phonemeIsolation/starts_with_s.mp3": 489,
	"./nn/phonemeIsolation/starts_with_v.mp3": 490,
	"./nn/rapidNaming/rapidNaming-intro1.mp3": 202,
	"./nn/rapidNaming/rapidNaming-intro2.mp3": 203,
	"./nn/rapidNaming/rapidNaming-intro3.mp3": 204,
	"./nn/rapidNaming/rapidNaming-intro4.mp3": 205,
	"./nn/rapidNaming/rapidNaming-intro5.mp3": 206,
	"./nn/spoonerism/correct-1.mp3": 237,
	"./nn/spoonerism/correct-2.mp3": 238,
	"./nn/spoonerism/correct-3.mp3": 239,
	"./nn/spoonerism/incorrect-1.mp3": 240,
	"./nn/spoonerism/incorrect-2.mp3": 241,
	"./nn/spoonerism/incorrect-3.mp3": 242,
	"./nn/spoonerism/intro-end.mp3": 54,
	"./nn/spoonerism/intro.mp3": 55,
	"./nn/spoonerism/proveoppgave-1.mp3": 243,
	"./nn/spoonerism/proveoppgave-2.mp3": 244,
	"./nn/spoonerism/proveoppgave-3.mp3": 245,
	"./nn/spoonerism/spoonerism-task (1).mp3": 246,
	"./nn/spoonerism/spoonerism-task (10).mp3": 247,
	"./nn/spoonerism/spoonerism-task (11).mp3": 248,
	"./nn/spoonerism/spoonerism-task (2).mp3": 249,
	"./nn/spoonerism/spoonerism-task (3).mp3": 250,
	"./nn/spoonerism/spoonerism-task (4).mp3": 251,
	"./nn/spoonerism/spoonerism-task (5).mp3": 252,
	"./nn/spoonerism/spoonerism-task (6).mp3": 253,
	"./nn/spoonerism/spoonerism-task (7).mp3": 254,
	"./nn/spoonerism/spoonerism-task (8).mp3": 255,
	"./nn/spoonerism/spoonerism-task (9).mp3": 256,
	"./nn/spoonerism/unk-spoonerism-task ().mp3": 491,
	"./nn/workingmemory_numbers/wmTrial-numbers-1.mp3": 170,
	"./nn/workingmemory_numbers/wmTrial-numbers-2.mp3": 171,
	"./nn/workingmemory_numbers/workingmemory-numbers-1.mp3": 172,
	"./nn/workingmemory_numbers/workingmemory-numbers-10.mp3": 181,
	"./nn/workingmemory_numbers/workingmemory-numbers-11.mp3": 182,
	"./nn/workingmemory_numbers/workingmemory-numbers-12.mp3": 183,
	"./nn/workingmemory_numbers/workingmemory-numbers-2.mp3": 173,
	"./nn/workingmemory_numbers/workingmemory-numbers-3.mp3": 174,
	"./nn/workingmemory_numbers/workingmemory-numbers-4.mp3": 175,
	"./nn/workingmemory_numbers/workingmemory-numbers-5.mp3": 176,
	"./nn/workingmemory_numbers/workingmemory-numbers-6.mp3": 177,
	"./nn/workingmemory_numbers/workingmemory-numbers-7.mp3": 178,
	"./nn/workingmemory_numbers/workingmemory-numbers-8.mp3": 179,
	"./nn/workingmemory_numbers/workingmemory-numbers-9.mp3": 180,
	"./nn/workingmemory_words/stop.mp3": 492,
	"./nn/workingmemory_words/wmTrial-words-1.mp3": 144,
	"./nn/workingmemory_words/wmTrial-words-2.mp3": 145,
	"./nn/workingmemory_words/workingmemory-words-1.mp3": 184,
	"./nn/workingmemory_words/workingmemory-words-10.mp3": 193,
	"./nn/workingmemory_words/workingmemory-words-11.mp3": 194,
	"./nn/workingmemory_words/workingmemory-words-12.mp3": 195,
	"./nn/workingmemory_words/workingmemory-words-2.mp3": 185,
	"./nn/workingmemory_words/workingmemory-words-3.mp3": 186,
	"./nn/workingmemory_words/workingmemory-words-4.mp3": 187,
	"./nn/workingmemory_words/workingmemory-words-5.mp3": 188,
	"./nn/workingmemory_words/workingmemory-words-6.mp3": 189,
	"./nn/workingmemory_words/workingmemory-words-7.mp3": 190,
	"./nn/workingmemory_words/workingmemory-words-8.mp3": 191,
	"./nn/workingmemory_words/workingmemory-words-9.mp3": 192,
	"./no/dictation/diktat-0.mp3": 56,
	"./no/dictation/diktat-1.mp3": 57,
	"./no/dictation/diktat-10.mp3": 58,
	"./no/dictation/diktat-11.mp3": 59,
	"./no/dictation/diktat-12.mp3": 103,
	"./no/dictation/diktat-13.mp3": 104,
	"./no/dictation/diktat-14.mp3": 60,
	"./no/dictation/diktat-15.mp3": 105,
	"./no/dictation/diktat-16.mp3": 106,
	"./no/dictation/diktat-17.mp3": 107,
	"./no/dictation/diktat-18.mp3": 61,
	"./no/dictation/diktat-19.mp3": 108,
	"./no/dictation/diktat-2.mp3": 62,
	"./no/dictation/diktat-20.mp3": 63,
	"./no/dictation/diktat-21.mp3": 109,
	"./no/dictation/diktat-22.mp3": 64,
	"./no/dictation/diktat-23.mp3": 65,
	"./no/dictation/diktat-24.mp3": 110,
	"./no/dictation/diktat-25.mp3": 66,
	"./no/dictation/diktat-26.mp3": 67,
	"./no/dictation/diktat-27.mp3": 68,
	"./no/dictation/diktat-28.mp3": 111,
	"./no/dictation/diktat-29.mp3": 69,
	"./no/dictation/diktat-3.mp3": 70,
	"./no/dictation/diktat-30.mp3": 71,
	"./no/dictation/diktat-31.mp3": 72,
	"./no/dictation/diktat-32.mp3": 73,
	"./no/dictation/diktat-33.mp3": 74,
	"./no/dictation/diktat-34.mp3": 75,
	"./no/dictation/diktat-35.mp3": 112,
	"./no/dictation/diktat-36.mp3": 113,
	"./no/dictation/diktat-37.mp3": 76,
	"./no/dictation/diktat-38.mp3": 114,
	"./no/dictation/diktat-39.mp3": 115,
	"./no/dictation/diktat-4.mp3": 77,
	"./no/dictation/diktat-5.mp3": 78,
	"./no/dictation/diktat-6.mp3": 79,
	"./no/dictation/diktat-7.mp3": 80,
	"./no/dictation/diktat-8.mp3": 81,
	"./no/dictation/diktat-9.mp3": 82,
	"./no/dictation/diktat-intro.mp3": 257,
	"./no/intros/letterKnowledge-intro.mp3": 258,
	"./no/intros/oneMinute-intro.mp3": 259,
	"./no/intros/pd-intro.mp3": 260,
	"./no/intros/phonemeIsolation-klarte-oppgaver.mp3": 208,
	"./no/intros/phonemeIsolation-starter-intro.mp3": 207,
	"./no/intros/testen-er-ferdig.mp3": 134,
	"./no/intros/workingmemory-numbers-intro.mp3": 138,
	"./no/intros/workingmemory-words-intro.mp3": 89,
	"./no/phonemeDeletion/brev-b.mp3": 261,
	"./no/phonemeDeletion/brev.mp3": 493,
	"./no/phonemeDeletion/bro-r.mp3": 262,
	"./no/phonemeDeletion/bro.mp3": 494,
	"./no/phonemeDeletion/broed-b.mp3": 263,
	"./no/phonemeDeletion/broed.mp3": 495,
	"./no/phonemeDeletion/brus-b.mp3": 496,
	"./no/phonemeDeletion/bry-r.mp3": 264,
	"./no/phonemeDeletion/bry.mp3": 497,
	"./no/phonemeDeletion/dansk-k.mp3": 498,
	"./no/phonemeDeletion/drap-d.mp3": 265,
	"./no/phonemeDeletion/drap.mp3": 499,
	"./no/phonemeDeletion/film-m.mp3": 500,
	"./no/phonemeDeletion/foere-f.mp3": 266,
	"./no/phonemeDeletion/foere.mp3": 267,
	"./no/phonemeDeletion/gaas-g.mp3": 268,
	"./no/phonemeDeletion/gaas.mp3": 501,
	"./no/phonemeDeletion/gris-g.mp3": 269,
	"./no/phonemeDeletion/gris.mp3": 270,
	"./no/phonemeDeletion/hans-s.mp3": 502,
	"./no/phonemeDeletion/helst-l.mp3": 503,
	"./no/phonemeDeletion/klaer-k.mp3": 271,
	"./no/phonemeDeletion/klaer.mp3": 504,
	"./no/phonemeDeletion/klart-t.mp3": 505,
	"./no/phonemeDeletion/klatre-t.mp3": 272,
	"./no/phonemeDeletion/klatre.mp3": 506,
	"./no/phonemeDeletion/laas-s.mp3": 273,
	"./no/phonemeDeletion/laas.mp3": 507,
	"./no/phonemeDeletion/lekse-k.mp3": 274,
	"./no/phonemeDeletion/lekse.mp3": 508,
	"./no/phonemeDeletion/loff-f.mp3": 275,
	"./no/phonemeDeletion/loff.mp3": 509,
	"./no/phonemeDeletion/maal-m.mp3": 276,
	"./no/phonemeDeletion/malt-l.mp3": 277,
	"./no/phonemeDeletion/malt.mp3": 510,
	"./no/phonemeDeletion/mars-r.mp3": 511,
	"./no/phonemeDeletion/pris-p.mp3": 512,
	"./no/phonemeDeletion/ris-r.mp3": 513,
	"./no/phonemeDeletion/sel-l.mp3": 278,
	"./no/phonemeDeletion/sel.mp3": 279,
	"./no/phonemeDeletion/ser-r.mp3": 514,
	"./no/phonemeDeletion/skyll-l.mp3": 280,
	"./no/phonemeDeletion/skyll.mp3": 515,
	"./no/phonemeDeletion/spoer-p.mp3": 516,
	"./no/phonemeDeletion/sport-p.mp3": 281,
	"./no/phonemeDeletion/sport.mp3": 517,
	"./no/phonemeDeletion/stoev-s.mp3": 518,
	"./no/phonemeDeletion/tap-p.mp3": 519,
	"./no/phonemeDeletion/tekst-k.mp3": 520,
	"./no/phonemeDeletion/trygg-t.mp3": 282,
	"./no/phonemeDeletion/trygg.mp3": 521,
	"./no/phonemeIsolation/ends_with_e.mp3": 522,
	"./no/phonemeIsolation/ends_with_i.mp3": 523,
	"./no/phonemeIsolation/ends_with_k.mp3": 524,
	"./no/phonemeIsolation/ends_with_n.mp3": 525,
	"./no/phonemeIsolation/ends_with_o.mp3": 526,
	"./no/phonemeIsolation/ends_with_p.mp3": 527,
	"./no/phonemeIsolation/ends_with_r.mp3": 528,
	"./no/phonemeIsolation/ends_with_t.mp3": 529,
	"./no/phonemeIsolation/ends_with_u.mp3": 530,
	"./no/phonemeIsolation/ends_with_y.mp3": 531,
	"./no/phonemeIsolation/starts_with_b.mp3": 532,
	"./no/phonemeIsolation/starts_with_e.mp3": 533,
	"./no/phonemeIsolation/starts_with_g.mp3": 534,
	"./no/phonemeIsolation/starts_with_h.mp3": 535,
	"./no/phonemeIsolation/starts_with_i.mp3": 536,
	"./no/phonemeIsolation/starts_with_k.mp3": 537,
	"./no/phonemeIsolation/starts_with_l.mp3": 538,
	"./no/phonemeIsolation/starts_with_oe.mp3": 539,
	"./no/phonemeIsolation/starts_with_s.mp3": 540,
	"./no/phonemeIsolation/starts_with_v.mp3": 541,
	"./no/rapidNaming/rapidNaming-intro1.mp3": 197,
	"./no/rapidNaming/rapidNaming-intro2.mp3": 198,
	"./no/rapidNaming/rapidNaming-intro3.mp3": 199,
	"./no/rapidNaming/rapidNaming-intro4.mp3": 200,
	"./no/rapidNaming/rapidNaming-intro5.mp3": 201,
	"./no/spoonerism/correct-1.mp3": 283,
	"./no/spoonerism/correct-2.mp3": 284,
	"./no/spoonerism/correct-3.mp3": 285,
	"./no/spoonerism/incorrect-1.mp3": 286,
	"./no/spoonerism/incorrect-2.mp3": 287,
	"./no/spoonerism/incorrect-3.mp3": 288,
	"./no/spoonerism/intro-end.mp3": 34,
	"./no/spoonerism/intro.mp3": 35,
	"./no/spoonerism/proveoppgave-1.mp3": 289,
	"./no/spoonerism/proveoppgave-2.mp3": 290,
	"./no/spoonerism/proveoppgave-3.mp3": 291,
	"./no/spoonerism/spoonerism-task (1).mp3": 292,
	"./no/spoonerism/spoonerism-task (10).mp3": 293,
	"./no/spoonerism/spoonerism-task (11).mp3": 294,
	"./no/spoonerism/spoonerism-task (12).mp3": 116,
	"./no/spoonerism/spoonerism-task (13).mp3": 117,
	"./no/spoonerism/spoonerism-task (14).mp3": 118,
	"./no/spoonerism/spoonerism-task (15).mp3": 119,
	"./no/spoonerism/spoonerism-task (16).mp3": 120,
	"./no/spoonerism/spoonerism-task (17).mp3": 121,
	"./no/spoonerism/spoonerism-task (18).mp3": 122,
	"./no/spoonerism/spoonerism-task (19).mp3": 123,
	"./no/spoonerism/spoonerism-task (2).mp3": 295,
	"./no/spoonerism/spoonerism-task (20).mp3": 124,
	"./no/spoonerism/spoonerism-task (3).mp3": 296,
	"./no/spoonerism/spoonerism-task (4).mp3": 297,
	"./no/spoonerism/spoonerism-task (5).mp3": 298,
	"./no/spoonerism/spoonerism-task (6).mp3": 299,
	"./no/spoonerism/spoonerism-task (7).mp3": 300,
	"./no/spoonerism/spoonerism-task (8).mp3": 301,
	"./no/spoonerism/spoonerism-task (9).mp3": 302,
	"./no/workingmemory_numbers/wmTrial-numbers-1.mp3": 140,
	"./no/workingmemory_numbers/wmTrial-numbers-2.mp3": 141,
	"./no/workingmemory_numbers/workingmemory-numbers-1.mp3": 146,
	"./no/workingmemory_numbers/workingmemory-numbers-10.mp3": 155,
	"./no/workingmemory_numbers/workingmemory-numbers-11.mp3": 156,
	"./no/workingmemory_numbers/workingmemory-numbers-12.mp3": 157,
	"./no/workingmemory_numbers/workingmemory-numbers-2.mp3": 147,
	"./no/workingmemory_numbers/workingmemory-numbers-3.mp3": 148,
	"./no/workingmemory_numbers/workingmemory-numbers-4.mp3": 149,
	"./no/workingmemory_numbers/workingmemory-numbers-5.mp3": 150,
	"./no/workingmemory_numbers/workingmemory-numbers-6.mp3": 151,
	"./no/workingmemory_numbers/workingmemory-numbers-7.mp3": 152,
	"./no/workingmemory_numbers/workingmemory-numbers-8.mp3": 153,
	"./no/workingmemory_numbers/workingmemory-numbers-9.mp3": 154,
	"./no/workingmemory_words/wmTrial-words-1.mp3": 142,
	"./no/workingmemory_words/wmTrial-words-2.mp3": 143,
	"./no/workingmemory_words/workingmemory-words-1.mp3": 158,
	"./no/workingmemory_words/workingmemory-words-10.mp3": 167,
	"./no/workingmemory_words/workingmemory-words-11.mp3": 168,
	"./no/workingmemory_words/workingmemory-words-12.mp3": 169,
	"./no/workingmemory_words/workingmemory-words-2.mp3": 159,
	"./no/workingmemory_words/workingmemory-words-3.mp3": 160,
	"./no/workingmemory_words/workingmemory-words-4.mp3": 161,
	"./no/workingmemory_words/workingmemory-words-5.mp3": 162,
	"./no/workingmemory_words/workingmemory-words-6.mp3": 163,
	"./no/workingmemory_words/workingmemory-words-7.mp3": 164,
	"./no/workingmemory_words/workingmemory-words-8.mp3": 165,
	"./no/workingmemory_words/workingmemory-words-9.mp3": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;